import { render, staticRenderFns } from "./FixedPriceTaskEdit.vue?vue&type=template&id=71ba1f8e&scoped=true"
import script from "./FixedPriceTaskEdit.vue?vue&type=script&lang=js"
export * from "./FixedPriceTaskEdit.vue?vue&type=script&lang=js"
import style0 from "./FixedPriceTaskEdit.vue?vue&type=style&index=0&id=71ba1f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba1f8e",
  null
  
)

export default component.exports